import { render, staticRenderFns } from "./ProductFuelPriceForm.vue?vue&type=template&id=5f1edfa8&scoped=true&"
import script from "./ProductFuelPriceForm.vue?vue&type=script&lang=js&"
export * from "./ProductFuelPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductFuelPriceForm.vue?vue&type=style&index=0&id=5f1edfa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1edfa8",
  null
  
)

export default component.exports